import Routes from "./Routes/Routes";
function App() {
  return (
    <div>      
          <Routes />
    </div>
  );
}


export default App;


